// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://seakhhfbaropdsjjxvll.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNlYWtoaGZiYXJvcGRzamp4dmxsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI3MTgwODIsImV4cCI6MjA4ODI5NDA4Mn0.-72nz6_r3oigb4ZVXUujAPBvMRnRImL_e7FQcne-TRA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});